"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault")["default"];
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.FixedArray = exports.EnqueReq = void 0;
exports.checkObsolete = checkObsolete;
exports.findParentOfNodeInTree = findParentOfNodeInTree;
exports.findTargetParentHtmlEl = void 0;
exports.fromObjToQueryStr = fromObjToQueryStr;
exports.loadJson = exports.isTouch = exports.fromRuleToObj = void 0;
exports.maketree = maketree;
exports.toLowerCaseKey = exports.measureCode2Label = void 0;
var _get3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/get"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createSuper"));
var _wrapNativeSuper2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/wrapNativeSuper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));
var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));
var _reduce = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/reduce"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
function checkObsolete(padre, optList) {
  if (!padre) return;
  if (padre.nodes) {
    for (var i = 0; i < padre.nodes.length; i++) {
      if (padre.nodes[i]) checkObsolete(padre.nodes[i], optList);
    }
  }
  var hasEnabled = false;
  (0, _forEach["default"])(optList).call(optList, function (x) {
    if (padre.cod === x.root) {
      if (x.enabletype !== 2) {
        hasEnabled = true;
      }
    }
  });
  if (padre.nodes) {
    for (var _i = 0; _i < padre.nodes.length; _i++) {
      if (!padre.nodes[_i].obsoleto) hasEnabled = true;
    }
  }
  if (!hasEnabled) {
    console.log('DISABLED', padre);
  }
  padre.obsoleto = !hasEnabled;
}
function findParentOfNodeInTree(node, tree) {
  var parentNode = null;
  for (var i = 0; i < tree.length; i++) {
    var tNode = tree[i];
    if (tNode.cod === node.root) parentNode = tNode;else if (tNode.nodes && tNode.nodes.length > 0) parentNode = findParentOfNodeInTree(node, tNode.nodes);
    if (parentNode !== null) break;
  }
  return parentNode;
}
function maketree(treeArray, treeToBuild) {
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var cod = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  if (treeArray) (0, _forEach["default"])(treeArray).call(treeArray, function (e) {
    var _context;
    if (e.livello == level && (!cod || (0, _startsWith["default"])(_context = e.cod).call(_context, cod))) {
      var x = {
        cod: e.cod,
        des: e.des,
        img: e.img,
        data: null
      };
      treeToBuild.push(x);
      if (e.haschilder) {
        x.data = [];
        maketree(treeArray, x.data, level + 1, x.cod);
      }
    }
  });
}
function fromObjToQueryStr(obj) {
  var _context2;
  return (0, _reduce["default"])(_context2 = (0, _keys["default"])(obj)).call(_context2, function (str, key, i) {
    var delimiter, val;
    delimiter = i === 0 ? '' : '&';
    key = encodeURIComponent(key);
    val = encodeURIComponent(obj[key]);
    return [str, delimiter, key, '=', val].join('');
  }, '');
}
var loadJson = function loadJson(filePath) {
  return fetch(filePath).then(function (response) {
    return response.json();
  });
};
exports.loadJson = loadJson;
var toLowerCaseKey = function toLowerCaseKey(obj) {
  var keys = (0, _keys["default"])(obj);
  var newobj = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    newobj[key.toLowerCase()] = obj[key];
  }
  return newobj;
};
exports.toLowerCaseKey = toLowerCaseKey;
var measureCode2Label = function measureCode2Label() {
  var code = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  switch (code) {
    case 'EX':
      return 'in';
    case 'CR':
      return 'mc';
    default:
      return code.toLowerCase();
  }
};
exports.measureCode2Label = measureCode2Label;
var fromRuleToObj = function fromRuleToObj(str) {
  if (str === undefined) {
    return {};
  }
  if (typeof str !== 'string') {
    throw "Input parameter must be an string";
  }
  var arr = str.split('\t');
  var obj = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i] == '') {
      continue;
    }
    var arr2 = arr[i].split('=');
    obj[arr2[0]] = arr2[1];
  }
  return obj;
};
exports.fromRuleToObj = fromRuleToObj;
var isTouch = function isTouch() {
  return true == ("ontouchstart" in window || window.DocumentTouch && document instanceof DocumentTouch);
};
exports.isTouch = isTouch;
var findTargetParentHtmlEl = function findTargetParentHtmlEl(value) {
  var searchBy = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'tag';
  var el = arguments.length > 2 ? arguments[2] : undefined;
  if (!el) return false;
  if (el.nodeName && el.nodeName.toLowerCase() === 'html') return false;
  if (searchBy === 'tag') {
    if (el.nodeName && el.nodeName.toLowerCase() === value) {
      return el;
    } else {
      return findTargetParentHtmlEl(value, searchBy, el.parentElement);
    }
  } else if (searchBy == 'id') {
    if (el.id === value) {
      return el;
    } else {
      return findTargetParentHtmlEl(value, searchBy, el.parentElement);
    }
  } else if (searchBy == 'class') {
    var _context3;
    if (el.className && (0, _indexOf["default"])(el.className) && (0, _indexOf["default"])(_context3 = el.className).call(_context3, value) > -1) {
      return el;
    } else {
      return findTargetParentHtmlEl(value, searchBy, el.parentElement);
    }
  } else return false;
};
exports.findTargetParentHtmlEl = findTargetParentHtmlEl;
var EnqueReq = /*#__PURE__*/function () {
  function EnqueReq() {
    (0, _classCallCheck2["default"])(this, EnqueReq);
    this.queueReq = null;
    this.queueTs = null;
    this.busy = false;
  }
  (0, _createClass2["default"])(EnqueReq, [{
    key: "pushReq",
    value: function pushReq(req, timestamp) {
      var _this = this;
      if (!this.busy) {
        this.busy = true;
        req()["finally"](function () {
          console.log('DONE');
          _this.checkQueue();
        });
      } else if (this.queueTs === null || timestamp > this.queueTs) {
        this.queueTs = timestamp;
        this.queueReq = req;
      }
    }
  }, {
    key: "checkQueue",
    value: function checkQueue() {
      var _this2 = this;
      if (this.queueReq !== null) {
        var req = this.queueReq;
        this.queueReq = null;
        this.queueTs = null;
        req()["finally"](function () {
          console.log('DONE');
          _this2.checkQueue();
        });
      } else {
        this.busy = false;
      }
    }
  }]);
  return EnqueReq;
}();
exports.EnqueReq = EnqueReq;
var FixedArray = /*#__PURE__*/function (_Array) {
  (0, _inherits2["default"])(FixedArray, _Array);
  var _super = (0, _createSuper2["default"])(FixedArray);
  function FixedArray(limit) {
    var _this3;
    (0, _classCallCheck2["default"])(this, FixedArray);
    if (arguments.length > 1) throw new Error('FixedArray accept only one argument used to limit the array size');
    if (isNaN(limit) || limit == null) throw new Error('limit parameter must be a number and not null');
    _this3 = _super.call(this);
    _this3.maxSize = limit;
    return _this3;
  }
  (0, _createClass2["default"])(FixedArray, [{
    key: "push",
    value: function push() {
      var _get2, _context4;
      for (var _len = arguments.length, items = new Array(_len), _key = 0; _key < _len; _key++) {
        items[_key] = arguments[_key];
      }
      if (this.length + items.length > this.maxSize) {
        while (this.length + items.length > this.maxSize) {
          this.shift();
        }
      }
      return (_get2 = (0, _get3["default"])((0, _getPrototypeOf2["default"])(FixedArray.prototype), "push", this)).call.apply(_get2, (0, _concat["default"])(_context4 = [this]).call(_context4, items));
    }
  }]);
  return FixedArray;
}( /*#__PURE__*/(0, _wrapNativeSuper2["default"])(Array));
exports.FixedArray = FixedArray;
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@3cad/nextcore/lib/commonjs/utils/utils.js
// module id = 235
// module chunks = 142